module.exports = __webpack_public_path__ + "static/media/Game4x4.edf88f12.png";